export const GET_EARNING_SCHEME = 'reference/earning'
export const GET_CURRENCY = 'reference/currency'
